/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import {
  AccordianBodyContainer,
  StyledImage,
  StyledText,
  LongTextContainer,
  LineWrapper,
  AccordionTitle,
  AccordionWrapper,
} from './styles';
import { Picture } from 'react-responsive-picture';
import { Grid, GridItem, GridRow } from './../Grid';
import { Text, Title } from './../Typography';
import { getPictureSources } from '../../lib/utils/helpers';
import { Accordion } from './../Accordion';

export const CorpTimelineAccordionWrapper = ({
  id = 'timeline-accordion',
  data,
}: {
  id?: any;
  data: any;
}) => {
  const name = 'CorpTimelineAccordionWrapper';
  const accordions = data?.corpTimelineAccordions.map((accordion: any, index: number) => {
    const accordionData = accordion?.corpTimelineAccordionItems.map((item: any, index: number) => {
      let body = <></>;
      const title = (
        <>
          <Title tag="div" type="xs" key={`${item?.title}-${index}-title`} className="mb-8">
            {item?.date}
          </Title>
        </>
      );

      if (item?.image) {
        // item.image === 'ImageRightTextLeft' || item.alignment === 'ImageLeftTextRight'
        body = (
          <AccordianBodyContainer $isReverse={false} key={`${item?.title}-${index}-body`}>
            <StyledImage>
              {item.image?.asset[0] ? (
                <Picture
                  className="rounded-2xl overflow-hidden w-full"
                  sources={getPictureSources(item.image?.asset[0])}
                  alt=""
                />
              ) : null}
            </StyledImage>
            <StyledText $isReverse={false}>
              {item.text?.html ? (
                <>
                  <Title className="mb-5" tag="div" type="sm" key={`${item?.title}-${index}-title`}>
                    {item?.title}
                  </Title>
                  <LongTextContainer data-test={`${id}-long-text`}>
                    <Text tag="div" type="md">
                      <div dangerouslySetInnerHTML={{ __html: item.text?.html }} />
                    </Text>
                  </LongTextContainer>
                </>
              ) : null}
            </StyledText>
          </AccordianBodyContainer>
        );
      } else {
        body = (
          <AccordianBodyContainer $isReverse={true} key={`${item?.title}-${index}-body`}>
            {item.text?.html ? (
              <div>
                <Title className="mb-5" tag="div" type="sm" key={`${item?.title}-${index}-title`}>
                  {item?.title}
                </Title>
                <LongTextContainer data-test={`${id}-long-text`}>
                  <Text tag="div" type="md">
                    <div dangerouslySetInnerHTML={{ __html: item.text?.html }} />
                  </Text>
                </LongTextContainer>
              </div>
            ) : null}
          </AccordianBodyContainer>
        );
      }

      return (
        <>
          <LineWrapper
            $lineTop={index === 0}
            $lineBottom={index < accordion?.corpTimelineAccordionItems?.length - 1}
            className="mb-8"
          >
            {title}
            {body}
          </LineWrapper>
        </>
      );
    });

    return (
      <Grid key={`timeline-item-${accordion?.id}`}>
        <GridRow columns={16}>
          <GridItem colSpan={16}>
            <AccordionWrapper>
              <Accordion
                data-test={`${id}-timeline-accordion`}
                name={name}
                collapsed={true}
                borderColor={'rgb(41, 43, 41)'}
                data={[
                  {
                    title: (
                      <>
                        <AccordionTitle
                          tag="div"
                          type="xl"
                          key={`accordion-${accordion.id}`}
                          className="mb-8"
                        >
                          {accordion.title}
                        </AccordionTitle>
                        <Title tag="div" type="md" key={`accordion-${accordion.id}`}>
                          {accordion.daterange}
                        </Title>
                      </>
                    ),
                    body: accordionData,
                  },
                ]}
                $isNumbered={false}
              />
            </AccordionWrapper>
          </GridItem>
        </GridRow>
      </Grid>
    );
  });
  return accordions;
};
